import PageContent from "../../components/PageContent";
import PageTitle from "../../components/PageTitle";
import SupplierUpdateForm from "./components/IndustryUpdateForm";

const SupplierConfigurations = () => {
    return (
        <>
            <PageTitle title="Configurações da empresa"/>
            <PageContent>
                <SupplierUpdateForm />
            </PageContent>
        </>
    )
}

export default SupplierConfigurations;